module.exports = __webpack_public_path__ + "assets/img/slogan-ac131baf.png";